// All copy uses the exact verbiage from the Hyltons Healthcare Solutions document.
export const COMPANY = {
  name: "Hyltons Healthcare Solutions",
  nameUpper: "HYLTONS HEALTHCARE SOLUTIONS",
  tagline: "Empowering care elevating lives.",
  website: "hhcsolutions.net",
  email: "info@hhcsolutions.net",
  phone: "(617) 842-8426",
  mobile: "(617) 842-8426",
  whatsapp: "16178428426",
  instagram: "hhcsolutions",
  instagramUrl: "https://instagram.com/hhcsolutions",
  instagramQR:
    "https://customer-assets.emergentagent.com/job_wellness-portal-307/artifacts/679xcvw2_%40HHCSOLUTIONS.JPG",
  address: {
    city: "Hyde Park",
    state: "MA 02136",
    country: "United States",
  },
  hours: [
    { day: "Monday", time: "8am – 5pm" },
    { day: "Tuesday", time: "8am – 5pm" },
    { day: "Wednesday", time: "8am – 5pm" },
    { day: "Thursday", time: "8am – 5pm" },
    { day: "Friday", time: "8am – 5pm" },
  ],
};

export const HERO = {
  eyebrow: "RELIABLE IN-HOME CARE SOLUTIONS",
  heading: "Expert In-Home Health Staffing",
  body:
    "Providing exceptional, trustworthy in-home healthcare staffing solutions tailored to meet your specific needs across the United States.",
  image:
    "https://customer-assets.emergentagent.com/job_wellness-portal-307/artifacts/mfgl5f0w_WEBH%208.webp",
};

export const HIGHLIGHTS = [
  "Personalized Caregiver Placement",
  "Comprehensive Nursing Services",
  "Flexible Staffing Solutions",
];

export const SERVICES = [
  {
    slug: "home-health-aide-support",
    title: "Home Health-Aide Support",
    icon: "HeartHandshake",
    description:
      "We offer tailored care plans to meet individual needs ensuring comfort, compassion, and independence at home. This service is under the guidance of our licensed clinical professionals.",
    image:
      "https://customer-assets.emergentagent.com/job_wellness-portal-307/artifacts/cp0qvhss_WEB%20H6jpg.webp",
  },
  {
    slug: "rehabilitation-and-therapy-solutions",
    title: "Rehabilitation and Therapy Solutions",
    icon: "Activity",
    description:
      "Comprehensive, Physical, Occupational, and Speech services to enhance recovery and mobility.",
    image:
      "https://customer-assets.emergentagent.com/job_wellness-portal-307/artifacts/h7frbnko_WEBH9.webp",
  },
  {
    slug: "respite-care-for-family-caregivers",
    title: "Respite Care for Family Caregivers",
    icon: "Users",
    description:
      "Professional nurses will provide expert medical care while monitoring and supporting patients in the comfort of their homes. All while providing temporary relief services for caregivers to take a break while ensuring patient care.",
    image:
      "https://customer-assets.emergentagent.com/job_wellness-portal-307/artifacts/it6qlddz_WEB%20H7.webp",
  },
  {
    slug: "medication-therapy-management",
    title: "Medication Therapy Management",
    icon: "Pill",
    description:
      "Clients have access to medication review services and counseling provides by licensed pharmacy professionals. This service promotes optimization in medication use and patient care.",
    image:
      "https://customer-assets.emergentagent.com/job_wellness-portal-307/artifacts/armrsyxi_WEB%20HHS5%20.webp",
  },
];

export const APPROACH = {
  heading: "Our Multidisciplinary Approach",
  intro: "We have experts from various fields on our care team.",
  motto: "Empowering Care, Elevating Lives",
  paragraphs: [
    "Represents the foundation that created our Health Care Staffing Agency.",
    "Our focus comes in light of filling the gap of meeting the demands of RELIABLE medical professionals in the healthcare workforce.",
    "We pride ourselves in placing our clients needs FIRST in every encounter, and boast the ABOVE and BEYOND mentality in each and every person on our care team.",
  ],
  image:
    "https://customer-assets.emergentagent.com/job_wellness-portal-307/artifacts/cp0qvhss_WEB%20H6jpg.webp",
};

export const TEAM = [
  {
    name: "Jenna Hylton, CPHT, MA",
    role: "Co-Founder",
    image:
      "https://customer-assets.emergentagent.com/job_wellness-portal-307/artifacts/57p8mi1b_Jenna%20Resume%20photoJPG.webp",
  },
  {
    name: "Dr. Bruce Hylton, PharmD, BS",
    role: "Co-Founder",
    image:
      "https://customer-assets.emergentagent.com/job_wellness-portal-307/artifacts/zytxk9vb_Resume%20photo%202026.jpeg",
  },
];

export const TESTIMONIALS = [
  {
    quote:
      "Hylton’s Healthcare Solutions has been a lifesaver for our family! Their PROFESSIONAL and COMPASSIONATE staff made a world of difference in my mother’s recovery. We couldn’t ask for better support during this crucial time.",
    author: "Kelly Thompson",
  },
  {
    quote:
      "Choosing Hylton’s Healthcare Solutions was the best decision for our family. Their skilled and empathetic staff ensured my father’s comfort and well-being at all times, providing us with peace of mind, truly OUTSTANDING service.",
    author: "Lisa Martinez",
  },
  {
    quote:
      "Hylton’s Healthcare Solutions provided my family with exceptional care and professionalism. Their dedicated team made my aunt transition to home care seamless, offering incredible support and compassion throughout. I’m grateful for their OUTSTANDING service and highly recommend them to anyone in need of reliable home health staffing.",
    author: "James Wilson",
  },
];
